<template>
    <el-container>
        <el-header v-if="!path" class="header">
            <div class="back" @click="goBack"><i class="el-icon-back"></i></div>
            <div class="title">文本导入</div>
            <div class="placeholder">1</div>
        </el-header>
        <el-main class="content-box" :class="!path ? 'content-box-height' : ''">
            <div class="edit-box" shadow="never">
                <div class="left">
                    <div class="head">
                        <p class="head-title">文本编辑</p>
                        <div class="head-btn">
                            <el-button type="text" size="mini" @click="dialogVisible = true">示例&帮助</el-button>

                                <el-upload
                                    class="upload-demo"
                                    accept=".doc,.docx"
                                    name="file"
                                    :http-request="uploadSectionFile"
                                    :show-file-list="false"
                                    ref="upload"
                                    action="#"
                                >
                                    <el-button size="mini">导入Word</el-button>
                                </el-upload>     
                            <el-button size="mini" @click="toClearText">清空文本</el-button>
                        </div>
                    </div>
                    <!-- <el-card class="edit-container"  shadow="never" :body-style="{ padding: '0px' }">
                        
                    </el-card> -->
                    
                    <el-input
                            class="textarea"
                            type="textarea"
                            placeholder="请将已准备好的文档按示例格式复制粘贴到这里"
                            v-model="editTextarea">
                            </el-input>
                </div>
                
                <div class="right">
                    <div class="head">
                        <p class="head-title">题目预览</p>
                        <el-button 
                            v-if="!path"
                            size="mini" 
                            type="primary" 
                            @click="createProject"
                        >创建项目</el-button>
                    </div>
                    <el-card class="edit-body"  shadow="never" :body-style="{ padding: '0px' }">
                        <p class="body-title">{{paper.title}}</p>
                        <p class="body-depict">{{paper.depict}}</p>
                        <div v-for="(item) in list" :key="item.qid">
                            <div class="question" v-if="item.questionsTypeId == 100 || item.questionsTypeId == 102">
                                <p class="subject">{{item.questionsName}} <span class="score" v-if="item.score > 0">({{item.score}}分)</span></p>
                                <el-radio-group v-model="item.noAnswer">
                                    <el-radio 
                                        class="option"
                                        v-for="info in item.optionList" 
                                        :key="info.oid" 
                                        :label="info.oid"
                                    >
                                        {{info.labelName}}
                                        <div 
                                            v-if="info.haveInput"
                                            class="other-input">
                                            <el-input
                                                size="mini"
                                                v-model="info.inputValue"
                                                >
                                            </el-input>
                                        </div>
                                        <span v-if="item.answer == info.oid" class="right-key">（正确答案）</span>
                                    </el-radio> 
                                </el-radio-group>
                            </div>
                            <div class="question" v-if="item.questionsTypeId == 101">
                                <p class="subject">{{item.questionsName}} <span v-if="item.score > 0" class="score">({{item.score}}分)</span></p>
                                <el-checkbox-group v-model="item.noAnswer">
                                    <el-checkbox 
                                        class="option"
                                        v-for="info in item.optionList" 
                                        :key="info.oid" 
                                        :label="info.oid"
                                        >
                                        {{info.labelName}} 
                                        <div 
                                            v-if="info.haveInput"
                                            class="other-input">
                                            <el-input
                                                size="mini"
                                                v-model="info.inputValue"
                                                >
                                            </el-input>
                                        </div>
                                        <span v-if="item.answer.indexOf(info.oid) != -1" class="right-key">（正确答案）</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="question" v-if="item.questionsTypeId == 204 || item.questionsTypeId == 206">
                                <p class="subject">{{item.questionsName}} <span v-if="item.score > 0" class="score">({{item.score}}分)</span></p>
                                <el-input
                                    resize="none"
                                    type="textarea"
                                    :rows="item.questionsTypeId == 204 ? 1 : 3"
                                    v-model="item.answer">
                                </el-input>
                            </div>
                            <div class="question" v-if="item.questionsTypeId == 401">
                                <p class="subject">{{item.questionsName}}</p>
                            </div>
                        </div>
                        
                    </el-card>
                </div>
            </div>
        </el-main>
        <el-dialog
            title="示例&帮助"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            width="50%">
            <div class="help scroll-body">
                <div class="list">
                    <p class="title">欢迎语：</p>
                    <div class="content">
                        <div class="left">
                            感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！【欢迎语】
                        </div>
                        <div class="right">
                            <p class="tips">预览示例</p>
                            <p>感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！</p>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">单选题：</p>
                        <div class="format-box" v-for="(item, index) in 3" :key="index">
                            <p class="format" v-if="index == 0">格式1：<span class="format-info">将“（正确答案）”备注在正确选项后面；</span></p>
                            <p class="format" v-else-if="index == 1">格式2：<span class="format-info">将正确答案以”正确答案：选项序号“的形式，另起一行备注在所有选项后面，所有选项默认序号以此为：A、B、C、D...；</span></p>
                            <p class="format" v-else-if="index == 2">格式3：<span class="format-info">将正确选项的序号用括号括起来，放在题目的中间或后面，所有选项默认序号依次为：A、B、C、D...；</span></p>
                            <div class="content">
                                <div class="left" v-if="index == 0">
                                    <p>我国的火警报警电话是（10分）【单选题】</p>
                                    <p>110</p>
                                    <p>120</p>
                                    <p>119（正确答案）</p>
                                    <p>911</p>
                                    <p>答案解析：我国的火警报警电话是119。</p>
                                </div>
                                <div class="left" v-else-if="index == 1">
                                    <p>我国的火警报警电话是（10分）【单选题】</p>
                                    <p>110</p>
                                    <p>120</p>
                                    <p>119</p>
                                    <p>911</p>
                                    <p>正确答案：C</p>
                                    <p>答案解析：我国的火警报警电话是119。</p>
                                </div>
                                <div class="left" v-else-if="index == 2">
                                    <p>我国的火警报警电话是（10分）（C）【单选题】</p>
                                    <p>110</p>
                                    <p>120</p>
                                    <p>119</p>
                                    <p>911</p>
                                    <p>答案解析：我国的火警报警电话是119。</p>
                                </div>
                                <div class="right">
                                    <p class="tips">预览示例</p>
                                    <p>我国的火警报警电话是<span class="score">(10分)</span></p>
                                    <el-radio-group disabled class="radio-box" v-model="radio">
                                        <el-radio>110</el-radio> 
                                        <el-radio>120</el-radio> 
                                        <el-radio>119<span class="right-key">（正确答案）</span>
                                        </el-radio> 
                                        <el-radio>911</el-radio> 
                                    </el-radio-group>
                                </div>
                            </div>
                        </div>
                    </div>
                <div class="list">
                    <p class="title">多选题：</p>
                    <div class="format-box" v-for="(item, index) in 3" :key="index + 3">
                        <p class="format" v-if="index == 0">格式1：<span class="format-info">将“（正确答案）”备注在正确选项后面；</span></p>
                        <p class="format" v-else-if="index == 1">格式2：<span class="format-info">将正确答案以”正确答案：选项序号“的形式，另起一行备注在所有选项后面，所有选项默认序号以此为：A、B、C、D...；</span></p>
                        <p class="format" v-else-if="index == 2">格式3：<span class="format-info">将正确选项的序号用括号括起来，放在题目的中间或后面，所有选项默认序号依次为：A、B、C、D...；</span></p>
                        <div class="content">
                            <div class="left" v-if="index == 0">
                                <p>东方神采多选题支持哪些计分方式？(10分)【多选题】</p>
                                <p>A.全部答对才得分（正确答案）</p>
                                <p>B.答对几项得几分，答错不得分（正确答案）</p>
                                <p>C.每个选项都有相应分值（正确答案）</p>
                                <p>答案解析：东方神采精多选题支持三种计分方式</p>
                            </div>
                            <div class="left" v-else-if="index == 1">
                                <p>东方神采多选题支持哪些计分方式？(10分)【多选题】</p>
                                <p>A.全部答对才得分</p>
                                <p>B.答对几项得几分，答错不得分</p>
                                <p>C.每个选项都有相应分值</p>
                                <p>正确答案：ABC</p>
                                <p>答案解析：东方神采精多选题支持三种计分方式</p>
                            </div>
                            <div class="left" v-else-if="index == 2">
                                <p>东方神采多选题支持哪些计分方式？(10分)（ABC）【多选题】</p>
                                <p>A.全部答对才得分</p>
                                <p>B.答对几项得几分，答错不得分</p>
                                <p>C.每个选项都有相应分值</p>
                                <p>答案解析：东方神采精多选题支持三种计分方式</p>
                            </div>
                            <div class="right">
                                <p class="tips">预览示例</p>
                                <p>我国的火警报警电话是<span class="score">(10分)</span></p>
                                <el-checkbox-group disabled class="radio-box" v-model="radio">
                                    <el-checkbox>A.全部答对才得分<span class="right-key">（正确答案）</span></el-checkbox> 
                                    <el-checkbox>B.答对几项得几分，答错不得分<span class="right-key">（正确答案）</span>
                                    </el-checkbox> 
                                    <el-checkbox>C.每个选项都有相应分值<span class="right-key">（正确答案）</span>
                                    </el-checkbox> 
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">判断题：</p>
                    
                        <p class="format"><span class="format-info">判断题可识别的“答案”格式包括：对/错、正确/错误、是/否、√/×。</span></p>
                    <div class="format-box" v-for="(item, index) in 2" :key="index + 6">
                        <p class="format"  v-if="index == 0">格式1：<span class="format-info">将正确答案以“正确答案：答案”的形式，另起一行备注在题目后面；</span></p>
                        <p class="format" v-else-if="index == 1">格式1：<span class="format-info">答案用括号括起来；</span></p>
                        <div class="content">
                            <div class="left" v-if="index == 0">
                                <p>腊月的最后一天为除日，所以腊月的最后一天晚上叫除夕。（10分）【判断题】</p>
                                <p>正确答案：是</p>
                                <p>答案解析：腊月的最后一天为除日，所以腊月的最后一天晚上叫除夕。</p>
                            </div>
                            <div class="left" v-if="index == 1">
                                <p>腊月的最后一天为除日，所以腊月的最后一天晚上叫除夕。（10分）(是)【判断题】</p>
                                <p>答案解析：腊月的最后一天为除日，所以腊月的最后一天晚上叫除夕。</p>
                            </div>
                            <div class="right">
                                <p class="tips">预览示例</p>
                                <p>腊月的最后一天为除日，所以腊月的最后一天晚上叫除夕。 <span class="score">(10分)</span></p>
                                <el-radio-group disabled class="radio-box" v-model="radio">
                                    <el-radio>是<span class="right-key">（正确答案）</span></el-radio> 
                                    <el-radio>否</el-radio> 
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">填空题：</p>
                    <p class="format"><span class="format-info">填空题的正确答案必须另起一行备注在题目后面；</span></p>
                    <div class="content">
                        <div class="left">
                            <p>《史记》的作者是？（10分）【填空题】</p>
                            <p>正确答案：司马迁</p>
                            <p>答案解析：司马迁</p>
                        </div>
                        <div class="right">
                            <p class="tips">预览示例</p>
                            <p>《史记》的作者是？ <span class="score">(10分)</span></p>
                            <p class="tiankong-answer">正确答案：司马迁</p>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">简答题：</p>
                    <p class="format"><span class="format-info">简答题的正确答案必须另起一行备注在题目后面；</span></p>
                    <div class="content">
                        <div class="left">
                            <p>东方神采logo中包含了哪个字母？（10分）【填空题】</p>
                            <p>正确答案：S</p>
                            <p>答案解析：S</p>
                        </div>
                        <div class="right">
                            <p class="tips">预览示例</p>
                            <p>东方神采logo中包含了哪个字母？ <span class="score">(10分)</span></p>
                            <p class="jianda-answer">正确答案：S</p>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">段落说明：</p>
                    <div class="content">
                        <div class="left">
                            请确认上述问题的答题，然后提交【段落说明】
                        </div>
                        <div class="right">
                            <p class="tips">预览示例</p>
                            <p>请确认上述问题的答题，然后提交</p>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">格式说明：</p>
                    <div class="content-format">
                        <p>1. 题目标题最好以数字开头；</p>
                        <p>2. 建议在题目后面添加题型标识，未标识的题目系统将自动识别；</p>
                        <p>3. 目前可识别的题型标识包括：【欢迎语】、【单选题】、【多选题】、【判断题】、【填空题】、【简答题】、【段落说明】；</p>
                        <p>4. 如果无法正确识别，请尝试在题目与题目之间加入空行；</p>
                        <p>5. 请勿在选项与选项之间空行。</p>
                        <p>6. 在【单选题】、【多选题】、【判断题】选项后增加“【文本填写】”字样，选项后会增加文本输入框。</p>
                        
                        <p>8. 结束语：【结束语-正常结束】</p>
                    </div>
                </div>
            </div>
            </el-dialog>
        <el-dialog
            title="清空文本"
            :visible.sync="clearDialogVisible"
            width="30%"
            center :close-on-click-modal="false"
            append-to-body>
            <span>确认清空文本吗？清空后，将无法恢复已输入文本</span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="clearDialogVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="doClearText">确 定</el-button>
            </span>
        </el-dialog>

    </el-container>
</template>

<script>

import { Paper } from "./js/editPaper.js";
export default {
    name: 'ExamImportQuestion',
    props: {
        path: {
            type: String,
            default: ''
        }
    },
    data() {
        return{
            editTextarea: `
项目标题
感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！【欢迎语】

1、我国的火警报警电话是（10分）【单选题】
110
120
119（正确答案）
911
答案解析：我国的火警报警电话是119。

2、东方神采多选题支持哪些计分方式？（30分）【多选题】
A、全部答对才得分
B、答对几项得几分，答错不得分
C、每个选项都有对应分值
正确答案：ABC
答案解析：东方神采最多支持三种计分方式

3、腊月的最后一天为除日，所以腊月的最后一天晚上叫除夕。（10分）【判断题】
正确答案：是

4、《史记》的作者是？(10分)【填空题】
正确答案：司马迁

5、东方神采logo中包含了哪个字母？(10分)【简答题】
正确答案：S
\n`,
            editBody: '',
            quesType: ['【单选题】','【多选题】','【判断题】','【填空题】','【简答题】','【段落说明】'],
            paper: {},
            list: [],
            dialogVisible: false,
            radio: '',
            clearDialogVisible: false,
            fullscreenLoading: false
        }
    },
    watch: {
        editTextarea: {
            handler(newV) {
                this.initialization(newV)
            },
        }
    },
    beforeCreate() {
        
    },
    created(){
        this.paper = new Paper()
        this.initialization(this.editTextarea)
    },
    methods: {
        uploadSectionFile(params) {
            let that = this
            var formData = new FormData();
            formData.append("file", params.file);
            let paramsUp = {
                that: that,
                url: `${that.$config.service.examimportWord}`,
                method: "post",
                data: formData,
                cb(res) {
                    // console.log(res)
                    if (res.code == '0') {
                        that.editTextarea = res.message
                    }
                },
            };
            that.$util.request(paramsUp);
        },
        initialization(newV) {
            this.paper.title = ''
            this.paper.depict = ''
            this.paper.questionsList = []
            let srArray = []
            srArray = newV.split('\n')
            for(let i = 0;i<srArray.length;i++){
                if (srArray[i] != ''){
                    this.paper.title = srArray[i]
                    srArray.splice(0, i+1)
                    break
                }
            }
            let arr = []
            let arr2 = []
            srArray.forEach((info, index) => {
                if (info) {
                    if(arr.length > 0) {
                        this.quesType.forEach((item) => {
                            if (info.indexOf(item) != -1) {
                                arr2.push(arr)
                                arr = []
                            }
                        })
                    }
                    arr.push(info)
                    if(index == srArray.length - 1 && arr.length > 0){
                        arr2.push(arr)
                        arr = []
                    }
                } else {
                    if(arr.length > 0){
                        if(index == 0) {
                            this.paper.title = arr[0]
                        }
                        arr2.push(arr)
                        arr = []
                    }
                }
            })
            arr2.forEach((info, index) =>{
                if(index == 0) {
                    // console.log(info)
                    info.forEach((el, elindex)=>{
                        if (el.indexOf('【欢迎语】') != -1 && elindex == 0){
                            this.paper.depict = el.slice(0, el.length-5)
                        }else {
                            arr.push(el)
                        }
                    })
                    if (arr.length > 0) {
                        this.paper.createQuestion(arr)
                        arr = []
                    }
                } else {
                    this.paper.createQuestion(info)
                }
                
            })
            
            this.list = JSON.parse(JSON.stringify(this.paper.questionsList))
            this.list.forEach(info =>{
                if(info.questionsTypeId == 204 || info.questionsTypeId == 206) {
                    info.answer = `正确答案：${info.answer}`
                }
            })
        },
        toClearText() {
            this.clearDialogVisible = true
        },
        doClearText() {
            this.editTextarea = ''
            this.clearDialogVisible = false
        },
        createProject() {
            let createTime = this.$functions.GetDate()
            const loading = this.$loading({
                lock: true,
                text: '正在创建',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            })
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.examProjectAdd}?paperType=1`,
                method: "post",
                cb(res) {
                    sessionStorage.setItem("examId", res)
                    let paperJson = JSON.parse(JSON.stringify(that.paper))
                    paperJson.questionsList.forEach((info) => {
                        // console.log(info)
                        if(info.questionsTypeId == 101) {
                            info.answer = info.answer.join(';')
                        }
                    })
                    let data = {
                        id: res,
                        paperjson: JSON.stringify(paperJson),
                        createTime: createTime,
                        updateTime: that.$functions.GetDate()
                    }
                    let paramsUp = {
                        that: that,
                        url: `${that.$config.service.examPaperAdd}`,
                        method: "post",
                        data: data,
                        cb(res) {
                        // console.log(res)
                        if (res.code == '0') {
                            loading.text = '创建成功'
                            setTimeout(() => {
                                loading.close()
                                that.$router.replace('/createExam')
                            }, 1000)
                        } else {
                            that.$message.error(res.message)
                            loading.close()
                        }
                        },
                    };
                    that.$util.request(paramsUp);
                },
            };
            this.$util.request(params);
        },
        goBack() {
            this.$router.go(-1)
        },
    }
}
</script>

<style lang="scss" scoped>
.el-container{
    height: 100%;
}
.header{
    display: flex;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
    justify-content: space-between;
    align-items: center;
    .back{
        [class^="el-icon-"]{
            color:#6d6d6d;
        }
        font-size: 24px;
        cursor: pointer;
        padding: 10px;
    }
    .title{
        font-size: 14px;
        color: #484848;
    }
    .placeholder{
        opacity: 0;
    }
}
.content-box-height{
    height: calc(100vh - 60px) !important;
}
.content-box{
    height: 600px;
    .edit-box{
        height: 100%;
        box-sizing: border-box;
        border: 1px solid #EBEEF5;
        background-color: #FFF;
        color: #303133;
        padding: 20px;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        .head-btn{
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 0px;
            /deep/.el-upload{
                margin: 0 10px;
            }
        }
        .head-title{
            color: #484848;
            font-size: 14px;
        }
        .head-title::before{
            content: "";
            display: inline-block;
            margin-right: 4px;
            width: 2px;
            height: 12px;
            background: #2672ff;
            border-radius: 1px;
            vertical-align: middle;
        }
        .head{
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 60px;
        }
        .left,.right{
            width: 49.5%;
        }
        .left{
            margin-right: .2%;
            /deep/.el-textarea{
                height: calc(100% - 60px);
            }
            /deep/.el-textarea__inner{
                box-sizing: border-box;
                padding: 50px;
                border: none;
                resize: none;
                border: 1px solid #eaeaea;
                height: 100%;
            }
        }
        .right{
            margin-left: .2%;
        }
        .edit-container,.edit-body{
            padding: 50px;
            box-sizing: border-box;
            border: 1px solid #eaeaea;
            overflow: auto;
            margin-right: .5%;
            border-radius: 4px;
            height: calc(100% - 60px);
        }
        
        .edit-body{
            .body-title{
                font-size: 24px;
                color: #484848;
                text-align: center;
                margin-bottom: 30px;
            }
            .body-depict{
                margin-bottom: 30px;
            }
            .question{
                margin-top: 30px;
                color: #484848;
                .subject{
                    margin-bottom: 20px;
                    .score{
                        color: #aeaeae;
                    }
                }
                
                .option{
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    .other-input{
                        width: 80px;
                        margin-left: 10px;
                    }
                    
                    .other-input /deep/.el-input--mini .el-input__inner{
                        height: 22px;
                        line-height: 22px;
                    }
                    
                    /deep/.el-checkbox__label,
                    /deep/.el-radio__label{
                        display: flex;
                        align-items: center;
                        white-space: normal;
                        word-break: break-all;
                        font-size: inherit;
                        text-decoration: inherit;
                    }
                    /deep/.el-checkbox__input{
                        display: inline-block;
                        margin-top:3px;
                    }
                }
            }
            /deep/.el-radio+.el-radio,/deep/.el-checkbox+.el-checkbox{
                margin-top: 10px;
            }
            /deep/.el-textarea__inner,.right-key{
                color: #00bf6f !important;
            }
        }
    }
}
/deep/.el-radio-group,/deep/.el-checkbox-group{
    display: flex;
    flex-direction: column;
}


.help{
    overflow-y: auto;
    height: 500px;
    .list{
        margin-bottom: 25px;
        .title{
            margin-bottom: 6px;
        }
        .format{
            font-size: 13px;
            margin-bottom: 12px;
            width: 48%;
            .format-info{
                color: #aeaeae;
            }
        }
        .format-box+.format-box{
            margin-top: 10px;
        }
        .content{
            display: flex;
            justify-content: space-between;
            .left{
                width: 48%;
                padding: 20px 24px;
                box-sizing: border-box;
                background: #f7f8fa;
                border-radius: 4px;
            }
            .right{
                width: 43%;
                padding: 5px 24px 0;
                border-radius: 4px;
                border: 1px solid #ebeef5;
                .tips{    
                    color: #aaa;
                    font-size: 12px;
                    text-align: right;
                }
                .score{
                    color: #aeaeae;
                }
                /deep/.el-radio+.el-radio,/deep/.el-checkbox+.el-checkbox{
                    margin-top: 5px;
                }
                /deep/.right-key{
                    color: #00bf6f !important;
                }
                .radio-box{
                    margin-top: 10px;
                }
                .tiankong-answer,.jianda-answer{
                    display: inline-block;
                    height: 30px;
                    width: 330px;
                    padding: 7px 12px;
                    font-size: 12px;
                    border: 1px solid #d8d8d8;
                    border-radius: 2px;    
                    color: #00bf6f!important;
                    box-sizing: border-box;
                    margin-top: 10px;
                    cursor: text;
                }
                .jianda-answer{
                    height: 75px;
                    margin-bottom: 10px;
                }
                /deep/.el-radio__input.is-disabled+span.el-radio__label,
                /deep/.el-checkbox__input.is-disabled+span.el-checkbox__label{
                    color: #606266;
                    cursor: auto;
                }
            }
            
        }
        .content-format{
            color: #484848;
            font-size: 12px;
            line-height: 20px;
        }
    }
}
</style>